import { useRole } from "../RoleContext"

export const hasAnyRequiredPermission = (requiredPermissions, currentPermissions) => {
    if (!requiredPermissions || requiredPermissions.length === 0) {
        return true
    }

    return requiredPermissions.some((permission) => currentPermissions.includes(permission))
}

export const RoleProtect = ({ children, allowedPermissions }) => {
    const { permissions } = useRole()

    if (!hasAnyRequiredPermission(allowedPermissions, permissions)) {
        return <></>
    }
    return children
}
